import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class CreateAnalyticPlanRule {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(
    company_id: number,
    accounts: string[],
    plan_code: string,
    level1_code: string,
    level2_code?: string,
    third_party_type?: string,
    third_party_id?: number,
    reference?: string
  ): Promise<any> {
    const args = {
      company_id,
      accounts,
      plan_code,
      level1_code,
      level2_code: level2_code || null,
      supplierdb_id: third_party_type === 'supplier' && third_party_id ? third_party_id : null,
      customerdb_id: third_party_type === 'customer' && third_party_id ? third_party_id : null,
      reference: reference || null
    };
    return await this.dispatcher.dispatch('create.analytic_plan_rule', args);
  }
}
